import React, { useMemo } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import Menu from '../sections/Menu';
import Footer from '../sections/Footer';
import FeaturesHero from '../sections/FeaturesHero';
import RegistrationMethods from '../sections/RegistrationMethods';
import PackageFeatures from '../sections/PackageFeatures';
import CTA from '../sections/CTA';
import AnimatedCounter from '../components/AnimatedCounter';
import PageMeta from '../seo/PageMeta';
import { buildServiceStructuredData } from '../seo/structuredData';

function Funkcje() {
  const featuresStructuredData = useMemo(
    () => [
      buildServiceStructuredData({
        path: "/funkcje",
        name: "Funkcje systemu eGodziny",
        description:
          "Zestaw funkcji eGodziny do rejestracji czasu pracy, grafiku i raportowania.",
        serviceType: "Oprogramowanie do ewidencji czasu pracy",
      }),
    ],
    []
  );

  return (
    <>
      <PageMeta path="/funkcje" structuredData={featuresStructuredData} />
      <Menu />
      <div style={{ paddingTop: '80px' }}>
        <FeaturesHero />
        <RegistrationMethods />
        <PackageFeatures />
      </div>

      {/* Case Study Section */}
      <div style={{ backgroundColor: '#ffffffff', paddingTop: '60px', paddingBottom: '60px' }}>
        <Container className="py-5">
          <div className="text-center" style={{ marginBottom: '48px' }}>
            <h2 style={{
              fontSize: '2.2rem',
              fontWeight: '700',
              color: '#1f2937',
              marginBottom: '16px'
            }}>
              U innych już się sprawdziło
            </h2>
          </div>

          <Row className="justify-content-center g-4">
            <Col lg={8} md={12}>
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '20px',
                  padding: '40px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
                }}
                onClick={() => window.open('/case-study/staldach-bud', '_self')}
              >
                <Row className="align-items-center mb-4">
                  <Col md={4} className="text-center mb-4 mb-md-0">
                    <div style={{ marginBottom: '20px' }}>
                      <Image
                        src={require('../images/staldach-bud-logo.png')}
                        alt="Staldach-Bud Logo"
                        style={{
                          width: '150px',
                          height: 'auto',
                        }}
                      />
                    </div>
                    <div style={{ marginTop: '25px', fontSize: '14px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                        Mariusz Wolny
                      </div>
                      <div style={{ color: '#666', marginBottom: '3px' }}>
                        Prezes Zarządu
                      </div>
                      <div style={{ color: '#666' }}>
                        STALDACH-BUD sp. z o.o.
                      </div>
                    </div>
                  </Col>

                  <Col md={8}>
                    <h3
                      style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        marginBottom: '15px',
                        color: '#1f2937',
                      }}
                    >
                      Jak Staldach-bud sp. z o.o. oszczędza ponad 9 tysięcy złotych miesięcznie
                    </h3>
                    <p
                      style={{
                        fontStyle: 'italic',
                        marginBottom: '20px',
                        color: '#333',
                        fontSize: '16px',
                        lineHeight: '1.5',
                      }}
                    >
                      "Jako przedsiębiorca wiecznie przytłoczony ilością zadań i obowiązków, nie zdawałem sobie sprawy, że w tak łatwy sposób można poprawić działanie firmy"
                    </p>
                    <div
                      style={{
                        fontSize: '2rem',
                        fontWeight: 'bold',
                        color: '#407EF9',
                        marginBottom: '10px',
                      }}
                    >
                      <AnimatedCounter value={9180} suffix=" zł" />
                    </div>
                    <p
                      style={{
                        fontSize: '14px',
                        margin: 0,
                        fontWeight: '500',
                        color: '#666',
                      }}
                    >
                      Miesięczne oszczędności
                    </p>
                  </Col>
                </Row>

                <div className="mt-auto text-end">
                  <Button
                    variant="outline-dark"
                    style={{
                      borderRadius: '10px',
                      padding: '8px 20px',
                      fontWeight: '600'
                    }}
                  >
                    Przeczytaj case study
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* CTA Section */}
      <CTA ctaText="Zobacz jak to działa w praktyce" />

      <Footer />
    </>
  );
}

export default Funkcje;
